import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, model, signal, untracked } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { PositionSideBarSearch } from '../../enums/position-side-bar-search';
import { SearchType } from '../../enums/search-type';
import { OpenSearchService } from '../../services/open-search.service';
import { OpenSearchDrawerService } from '../../services/open-search-drawer.service';
import { OpenSearchComponent } from '../open-search/open-search.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  selector: 'app-sidebar-open-search',
  imports: [
    OpenSearchComponent,
    MatIconModule,
    MatTooltipModule,
    MatDividerModule,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './sidebar-open-search.component.html',
  styleUrl: './sidebar-open-search.component.scss',
})
export class SidebarOpenSearchComponent {
  workspace = input(false);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private openSearchService = inject(OpenSearchService);
  drawer = inject(OpenSearchDrawerService);
  positionContainer = model<PositionSideBarSearch>();
  searchType = model<SearchType>();
  showAllResults = model<boolean>(false);
  new = signal(SearchType.NEW);
  quick = signal(SearchType.QUICK);
  recent = signal(SearchType.RECENT);
  private isOpenInUrl = toSignal(
    this.route.queryParamMap.pipe(map(p => p.get('isOpenSideBarSearch') === 'true')),
    { initialValue: this.route.snapshot.queryParamMap.get('isOpenSideBarSearch') === 'true' },
  );
  isOpen = computed(() => this.positionContainer() === PositionSideBarSearch.RIGHT);

  constructor() {
    effect(() => {
      const isOpenInUrl = this.isOpenInUrl();
      untracked(() =>
        this.positionContainer.set(
          isOpenInUrl ? PositionSideBarSearch.LEFT : PositionSideBarSearch.RIGHT,
        ),
      );
    });
  }

  private setOpenInUrl(open: boolean) {
    void this.router.navigate([], {
      queryParams: { isOpenSideBarSearch: open ? 'true' : null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  handlePositionContainer() {
    const isCurrentlyOpen = this.positionContainer() === PositionSideBarSearch.LEFT;
    this.setOpenInUrl(!isCurrentlyOpen);
  }

  togglePanelbar(type?: SearchType) {
    const isRecentOrQuick = type === this.recent() || type === this.quick();
    const isNew = type === this.new();

    if (!type) {
      const responseViewlocal = localStorage.getItem('responseView');
      if (responseViewlocal) {
        localStorage.removeItem('responseView');
        localStorage.removeItem('lastOpenSearchPath');
      }
    }
    if (isRecentOrQuick) {
      this.searchType.set(type);
      this.showAllResults.set(true);
      this.openSearchService.historyResponse.set(null);
      if (type === this.quick()) this.openSearchService.getPromts(0, false);
      if (type === this.recent()) this.openSearchService.getRecentSeaeches();
    }
    if (isRecentOrQuick || isNew) {
      localStorage.removeItem('OpenSearchPath');
      localStorage.removeItem('lastOpenSearchPath');
      localStorage.removeItem('responseView');
      this.openSearchService.historyResponse.set(null);
      this.openSearchService.conversationIdSignal.set(null);
      this.openSearchService._dataOpenLogic.set(null);
    }
    this.handlePositionContainer();
  }
}
